window._ = require("lodash");
import Notifications from "vue-notification";
import VueMask from "v-mask";

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");

    require("bootstrap");
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo";

window.Pusher = require("pusher-js");

window.Echo = new Echo({
    broadcaster: "pusher",
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: "eu",
    enabledTransports: ["ws", "wss"],
});

import Vue from "vue/dist/vue";
window.Vue = Vue;

Vue.use(Notifications);
Vue.use(VueMask);
Vue.component("register-form", require("./components/registerForm").default);
Vue.component("login-form", require("./components/loginForm").default);
Vue.component("payment-form", require("./components/paymentForm").default);
Vue.component("webinar", require("./components/webinar").default);
Vue.component("chat", require("./components/chat").default);
Vue.component("notify", require("./components/notify").default);
Vue.component(
    "profile-certificates",
    require("./components/profileCertificates").default
);
Vue.component("user-data", require("./components/userData").default);
Vue.component("program", require("./components/program").default);
Vue.component(
    "program-session",
    require("./components/programSession").default
);
Vue.component(
    "program-lecture",
    require("./components/programLecture").default
);

export const functions = {
    catchApiErrors: (errorResponse, component) => {
        if (errorResponse.response.data.errors) {
            Object.entries(errorResponse.response.data.errors).forEach(
                function (field) {
                    field[1].forEach(function (error) {
                        component.$notify({
                            group: "foo",
                            type: "error",
                            title: error,
                        });
                    });
                }
            );
        }
    },
};

Vue.prototype.$functions = functions;

const app = new Vue({
    el: "#app",
});
